import React from 'react';
import './App.css';
import Landingpage from './pages/landingpage';
import ScrollToHash from './components/scrollhash';

function App() {

  return (
    
   <div>
     <ScrollToHash />
    <Landingpage />
    </div>
  
  );
}

export default App;
